import EdoSubmitApplications from './EdoSubmitApplications';

export default EdoSubmitApplications;
